import { useEffect, useState } from "react";
import axios from "axios";
import { AnimatePresence, motion } from "framer-motion";
import { Star, Quote, PenLine } from "lucide-react";
import Reveal from "./Reveal";
import ReviewForm from "./ReviewForm";
import { TESTIMONIALS } from "../data/content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Testimonials = () => {
  const [reviews, setReviews] = useState([]);
  const [writing, setWriting] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/reviews`)
      .then((r) => setReviews(r.data))
      .catch(() => {});
  }, []);

  const cards = [...reviews, ...TESTIMONIALS.slice(0, Math.max(0, 3 - reviews.length))];

  return (
    <section id="reviews" data-testid="testimonials-section" className="mx-auto max-w-7xl px-5 py-24 sm:px-8 lg:py-32">
      <Reveal>
        <div className="mb-14 text-center">
          <p className="text-[11px] font-medium uppercase tracking-[0.35em] text-[#C5A059]">Guest Stories</p>
          <h2 className="mt-4 font-display text-4xl font-light text-[#F5F2EB] sm:text-5xl">Words From Our Guests</h2>
        </div>
      </Reveal>
      <div className="grid gap-6 md:grid-cols-3" data-testid="testimonials-grid">
        {cards.map((t, i) => (
          <Reveal key={t.id || t.name} delay={(i % 3) * 0.1}>
            <blockquote data-testid={`testimonial-${i}`} className="flex h-full flex-col border border-[#2A2421] bg-[#161311] p-8">
              <Quote size={24} className="text-[#8C713B]" fill="#2A2421" />
              <div className="mt-4 flex gap-1" data-testid={`testimonial-rating-${i}`}>
                {Array.from({ length: t.rating }).map((_, s) => (
                  <Star key={s} size={13} fill="#C5A059" className="text-[#C5A059]" />
                ))}
              </div>
              <p className="mt-4 flex-1 font-display text-lg font-light italic leading-relaxed text-[#E4D9C5]">“{t.quote}”</p>
              <footer className="mt-6 border-t border-[#2A2421] pt-4">
                <p className="text-sm font-medium text-[#F5F2EB]">{t.name}</p>
                {t.city && <p className="text-[10px] uppercase tracking-[0.25em] text-[#78716C]">{t.city}</p>}
              </footer>
            </blockquote>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1} className="mt-12 flex justify-center">
        <button
          data-testid="write-review-button"
          onClick={() => setWriting((w) => !w)}
          className="flex items-center gap-3 border border-[#2A2421] px-8 py-4 text-[11px] font-semibold uppercase tracking-[0.25em] text-[#F5F2EB] transition-all duration-300 hover:border-[#C5A059] hover:text-[#C5A059]"
        >
          <PenLine size={15} /> {writing ? "Close" : "Write a Review"}
        </button>
      </Reveal>

      <AnimatePresence initial={false}>
        {writing && (
          <motion.div
            key="review-form"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
            className="mx-auto mt-8 max-w-3xl overflow-hidden"
          >
            <ReviewForm onDone={() => setWriting(false)} />
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};

export default Testimonials;
